<template>
    <div :class="`star-rating-${align} star-rating `">
        <label for="rating">{{ fieldLabel }}</label>
        <div class="stars">
            <span
                v-for="(star, index) in 5"
                :key="index"
                :class="{'rated': index < rating}"
                @click="setRating(index + 1)">
                ★
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormStarRating",
    props: {
        fieldLabel: {
            type: String,
            required: true,
        },
        align: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            default: () => ({ rating: 0 })
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            rating: this.value.rating,
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.rating = newValue.rating;
            },
            deep: true
        }
    },
    methods: {
        setRating(value) {
            this.rating = value;
            this.emitValues();
        },
        emitValues() {
            this.$emit("input", {
                rating: this.rating,
                fieldLabel: this.fieldLabel
            });
        }
    },
    mounted() {
        this.emitValues();
    }
};
</script>

<style lang="scss" scoped>
.star-rating-left {
    display: flex !important;
    align-items: center;
    padding: 10px;

    > label {
        font-size: 14px !important;
        width: 150px;
    }

    .stars {
        width: 100% !important;
    }
}

.star-rating-right {
    display: flex !important;
    align-items: center;
    padding: 10px;

    > label {
        font-size: 14px !important;
        width: 150px;
        text-align: right;
        margin-right: 5px;
    }

    .stars {
        width: 100% !important;
    }
}

.star-rating {
    width: 100%;
    max-width: 600px;
    margin: 10px auto;
    text-align: left;
    padding: 10px;

    > label {
        display: block;
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #2c3e50;
    }

    .stars {
        display: flex;
        gap: 5px;
        font-size: 24px;

        span {
            cursor: pointer;
            color: #d3d3d3;
            transition: color 0.2s;
        }

        .rated {
            color: #ffc107;
        }
    }

    p {
        font-size: 12px;
        color: #8696a0;
        margin-top: 5px;
    }
}
</style>